import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
import Vue from 'vue';
import moment from 'moment';
import { i18n } from '@/boot/i18n'; // Capitalise the first character of a string

Vue.filter('capitalise', function (value) {
  if (!value) {
    return '';
  }

  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}); // Convert a string to lower case

Vue.filter('lowerCase', function (value) {
  if (!value) {
    return '';
  }

  return value.toString().toLowerCase();
}); // Convert a string to upper case

Vue.filter('upperCase', function (value) {
  if (!value) {
    return '';
  }

  return value.toString().toUpperCase();
}); // Convert number into a decimal, x with decimalPlaces

Vue.filter('decimal', function (val) {
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var forceLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  val = Number(val);
  return val && val.toLocaleString(undefined, {
    maximumFractionDigits: decimalPlaces,
    minimumFractionDigits: forceLength ? decimalPlaces : null
  }) || '0';
});
Vue.filter('currency', function (val) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GBP';
  val = Number(val);
  return val && val.toLocaleString(undefined, {
    style: 'currency',
    currency: currency // minimumFractionDigits: 2,
    // maximumFractionDigits: 2,

  });
}); // Prettify the date

Vue.filter('prettyDate', function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LLL';
  value = typeof value === 'string' ? moment(value) : value;
  value.locale(i18n.locale);
  return value.format(format);
}); // Convert a Numeric value in bytes to its shortest, human readable form (e.g. 1000 -> 1 KB)

Vue.filter('prettyBytes', function (num) {
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  var neg = num < 0;

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  } // Determine which unit to use via exponent:


  var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1); // Determine the 'base', to 2 decimal places, cast as a Number (hence the * 1)

  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  var unit = units[exponent];
  return (neg ? '-' : '') + num + ' ' + unit;
}); // Replace new lines with breakTag

Vue.filter('nl2br', function (str) {
  var breakTag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '<br />';

  if (typeof str === 'undefined' || !str) {
    return '';
  }

  return str.toString().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
});